import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
//Components
import MainCard from '../../components/MainCard/MainCard';
import TabelaListagem from '../../components/TabelaListagem/TabelaListagem';
import FichaGerador from '../Cadastros/Geradores/FichaGerador';
import Loading from '../../components/Loading/Loading';

//Constants
import { actionsTable } from '../../constants/MaterialTable';

//Api
import gerador_api from '../../api/gerador_api';

//Shared
import FiltroPrefeitura from '../../views/Shared/FiltroPrefeitura';
import { showMessage } from 'helpers/message';

export default function GrandeGeradorSemContrato() {
    //Estado que guarda os geradores
    const [geradores, setGeradores] = useState([]);

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Variavel que pega os dados do state de navegação
    const location = useLocation();

    //Filtros que vem da location
    const { statusParam, titleTable } = location.state ? location.state : {};

    //Variavel que faz o controle da navegação na tela
    const navigate = useNavigate();

    //Estado de controle de apresentação da ficha do grande gerador
    const [ficha, setFicha] = useState();

    //Função que carrega os geradores sem contrato
    const loadGeradores = (prefeituraId = null) => {
        setLoading(true);
        prefeituraId = prefeituraId ? prefeituraId : prefeitura_Id;
        gerador_api.GetListSemContrato({ prefeitura_id: prefeituraId, status: statusParam ? statusParam : "Todos" }).then(response => {
            setGeradores(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    //Estado que guarda o id da prefeitura selecionada no select das prefeituras no ambiente privado ou da prefeitura default no ambiente público
    const [prefeitura_Id, setPrefeitura_Id] = useState(null);
    const handlePrefeitura = (value) => {
        setPrefeitura_Id(value);
        loadGeradores(value);
    }

    //Ações da tabela de listagem
    const actions = [
        actionsTable.visualizar((rowData) => setFicha(rowData.id))
    ]

    //Cabeçalhos da tabela de listagem
    const headers = [
        { value: "Fantasia", objectValue: "fantasia" },
        { value: "Razão Social", objectValue: "razao" },
        { value: "CPF / CNPJ", objectValue: "cpfcnpj" },
        { value: "Status", objectValue: "status" },
        { value: "Modalidade de Coleta", objectValue: "modalidadeColeta" },
        { value: "Validade do Contrato", objectValue: "validadeCadastro" },
    ]



    if (ficha)
        return <FichaGerador id={ficha} btnVoltar={() => setFicha(null)} permissao="Visualizar" />
    return (
        <MainCard btnVoltar={location.state && location.state.btnVoltar ? () => navigate(location.state.btnVoltar) : null} noCard>
            {loading && <Loading />}
            <FiltroPrefeitura handleValue={handlePrefeitura}></FiltroPrefeitura>
            <TabelaListagem actions={actions} options={{ print: false, search: true, pagination: true }} headers={headers} items={geradores} title={titleTable ? titleTable : "Lista de grandes geradores sem contratos"} />
        </MainCard>
    )
}